import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import LoginDefault from "./LoginDefault";
import LoginIdpPage from "./LoginIdp";
import LoginNotPortalPage from "./LoginNotPortal";
import LoginTrading from "./LoginTrading";
import LoginBranded from "./LoginBranded";

function Login() {
  const { variant, brand } = useScreenVariant();

  switch (variant) {
    case ScreenVariant.IDP:
      return <LoginIdpPage />;
    case ScreenVariant.TRADING:
      return <LoginTrading />;
    case ScreenVariant.NOT_PORTAL:
      return <LoginNotPortalPage />;
    case ScreenVariant.BRANDED:
      return (
        <BrandScope brand={brand}>
          <LoginBranded />
        </BrandScope>
      );
    default:
      return <LoginDefault />;
  }
}

export default Login;
